import React from 'react';
import {
  columnCreatedOn,
  columnPublisher,
  columnCollections,
  columnStatus,
  columnUpdatedOn,
  columnVisibility,
  hasColumn,
} from '@/constants/fields';
import UnsortedColumn from '@/components/table/UnsortedColumn';
import TableSortedColumn from '@/components/table/TableSortedColumn';
import NameDescriptionColumns from '@/components/table/NameDescriptionColumns';

const DatasetsTableColumnsWrapper = ({
  category,
  columns = [],
  items,
  onCheckBoxClick,
  onOrderByColumn,
  orderBy,
  singleSorting,
}) => (
  <NameDescriptionColumns
    entity="dataset"
    onCheckBoxClick={onCheckBoxClick}
    items={items}
    columns={columns}
    category={category}
    onOrderByColumn={onOrderByColumn}
    orderBy={orderBy}
    singleSorting={singleSorting}
  >
    {hasColumn(columns, columnPublisher) && (<UnsortedColumn columnId={columnPublisher} />)}
    {hasColumn(columns, columnCollections) && (<UnsortedColumn columnId={columnCollections} />)}
    {hasColumn(columns, columnVisibility) && (
    <TableSortedColumn
      name={columnVisibility}
      onOrderByColumn={onOrderByColumn}
      orderBy={orderBy}
      singleSorting={singleSorting}
      sortable={category}
    />
    )}
    {hasColumn(columns, columnCreatedOn) && (
    <TableSortedColumn
      name={columnCreatedOn}
      onOrderByColumn={onOrderByColumn}
      orderBy={orderBy}
      singleSorting={singleSorting}
      sortable={category}
    />
    )}
    {hasColumn(columns, columnUpdatedOn) && (
    <TableSortedColumn
      name={columnUpdatedOn}
      onOrderByColumn={onOrderByColumn}
      orderBy={orderBy}
      singleSorting={singleSorting}
      sortable={category}
    />
    )}
    {hasColumn(columns, columnStatus) && (<UnsortedColumn columnId={columnStatus} />)}
  </NameDescriptionColumns>
);

export default DatasetsTableColumnsWrapper;
